import { POST } from "../../index";

export const selectCarRoute = (param) => POST("/v2/CarRoute/selectCarRoute", param);
export const insertCarRoute = (param) => POST("/v2/CarRoute/insertCarRoute", param);
export const updateCarRoute = (param) => POST("/v2/CarRoute/updateCarRoute", param);
export const deleteCarRoute = (param) => POST("/v2/CarRoute/deleteCarRoute", param);
